<template>
  <v-container fluid class="pt-1">
    <v-layout column wrap mb-0>
      <v-text-field
        outline
        :label="$t('name')"
        data-vv-name="name"
        v-model="value.name"
        v-validate="'required'"
        :data-vv-as="$t('name')"
        :error-messages="errors.collect('name')"
      />
      <v-text-field
        outline
        :label="$t('fa_name')"
        data-vv-name="fa_name"
        v-model="value.fa_name"
        v-validate="'required'"
        :data-vv-as="$t('fa_name')"
        :error-messages="errors.collect('fa_name')"
      />
      <v-text-field
        outline
        v-validate="'required'"
        :label="$t('base_rate')"
        data-vv-name="base_rate"
        v-model="value.base_rate"
        :data-vv-as="$t('base_rate')"
        :error-messages="errors.collect('base_rate')"
      />
    </v-layout>
    <v-btn color="primary" class="mx-0" @click="save">{{$t('save')}}</v-btn>
  </v-container>
</template>

<script>
export default {
  props: ["value"],
  methods: {
    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios.post("currencies", this.value).then(res => {
            this.value.id = res.data.data.id;
            this.loading = false;
            this.$store.commit("showSnackbar", {
              text: this.$t("save_succeed"),
              stateType: "success",
              show: true
            });
            this.$emit("saved", res.data.data);
          });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    }
  },
  watch: {
    value: function(val) {
      this.$emit("input", val);
    }
  }
};
</script>